import {
  SubmittalDocumentOptionDto,
  SubmittalDto,
} from 'src/api/FiretrolApiClient';
import { submittalApiClient } from 'src/api/FiretrolApiClientInstances';
import { createModuleQueries } from 'src/api/queries/workflowModules/createModuleQueries';
import { queryKeys } from 'src/api/queries/queryKeys';

const queries = createModuleQueries<SubmittalDto, SubmittalDocumentOptionDto>({
  label: 'submittal',
  listKey: queryKeys.submittals.list,
  detailKey: queryKeys.submittals.detail,
  documentOptionsKey: queryKeys.submittals.documentOptions,
  list: (jobId, ct) => submittalApiClient.getSubmittalsByJob(jobId, ct),
  detail: (jobId, id, ct) => submittalApiClient.getSubmittalById(jobId, id, ct),
  documentOptions: (jobId, ct) =>
    submittalApiClient.getDocumentOptions(jobId, ct),
});

export const useSubmittalsList = queries.useList;
export const useSubmittal = queries.useDetail;
export const useSubmittalDocumentOptions = queries.useDocumentOptions;
